import { useContext } from 'preact/compat'
import BaseContext from 'contexts/base-context'
import { FormSetting, Wordings } from 'scripts/type'

export default function useTranslation() {
  const { formSetting } = useContext(BaseContext)

  return (name: keyof Wordings, defaultValue?: string): any => {
    const wordings = getWordings(formSetting)
    return wordings?.[name] || defaultValue
  }
}

function getWordings(formSetting?: FormSetting) {
  return formSetting?.localeSetting?.wordings
}
